import useAppModal from 'hooks/useAppModal';
import OwnerNotesModal, { ownerNotesModalId } from './OwnerNotesModal';

interface OwnerNotesModalProps {
  notes: string;
}

const useOwnerNotesModal = () => {
  const { openModal, closeModal } = useAppModal();

  const handleClose = () => {
    closeModal(ownerNotesModalId);
  };

  const openOwnerNotesModal = ({ notes }: OwnerNotesModalProps) => {
    openModal({
      id: ownerNotesModalId,
      customContent: <OwnerNotesModal notes={notes} onClose={handleClose} />,
    });
  };

  return {
    openOwnerNotesModal,
  };
};

export default useOwnerNotesModal;
